<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				:header="tableHeader"
				queryData="VISSQuotationAuditLineViewInfoWX"
				:filter_thousandth="['PriceREMARK','Old_Unit_Price','New_Unit_Price','moq','order_addqty','net_price',
				'batch_floor_limit','Area','Shipment_Cycle']"
				:option="tableOption"
				:checkflg="false"></wTable>
		<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[8197]')" queryData="VISSQuotationAuditLineViewInfoWX" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
		<serce :isVisible="isVisible" queryData="VISSQuotationAuditLineViewInfoWX" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'wxpricedetail',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('wxpricedetail'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			tableHeader: [],
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
        that.$nextTick(function(){
            that.$processdata.initForm()
        });
	},
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('VISSQuotationAuditLineViewInfoWX',0,PFileds=>{
			that.tableHeader = PFileds;
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8197]"),this.$t("getapi[13]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 521, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 521, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('wxpricedetail',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'VISSQuotationAuditLineViewInfoWX');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/ISS/PQAudit/VISSQuotationAuditLine', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/ISS/PQAudit/VISSQuotationAuditLineExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "VISSQuotationAuditLineViewInfoWX",
                fromname: that.$t('getapi[8197]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
